import { combineReducers } from 'redux';

import fsConfigReducer from './fsConfigReducer';

export default (combineReducers({
  fsConfigReducer,
}));